import { render, staticRenderFns } from "./wrestler_class_passes.vue?vue&type=template&id=481274b0&"
import script from "./wrestler_class_passes.vue?vue&type=script&lang=js&"
export * from "./wrestler_class_passes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports